<img class="img--mobile-compatible creditCardImg" [src]="imgSrc()" [alt]="altText()" />
